import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
interface InlineCTAProps {
  label: string;
  position: string;
}
export function InlineCTA({
  label,
  position
}: InlineCTAProps) {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <div className="w-full flex justify-center mt-8 mb-4" data-id="element-91">
      <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={() => trackCTAClick(label, position)} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full sm:w-auto bg-brand-green hover:bg-brand-green/90 text-white font-sans font-bold text-base sm:text-lg py-4 px-6 rounded-xl shadow-md transition-colors flex items-center justify-center gap-2 no-underline text-center" data-id="element-92">
        {label}
        <ArrowRight className="w-5 h-5" data-id="element-93" />
      </motion.a>
    </div>;
}